/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddUserCommand } from '../models/AddUserCommand';
import type { SearchedUserDto } from '../models/SearchedUserDto';
import type { UserInfoDto } from '../models/UserInfoDto';
import type { UserListDtoPaginatedResult } from '../models/UserListDtoPaginatedResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * @param searchTerm
     * @returns SearchedUserDto OK
     * @throws ApiError
     */
    public static getApiUsersEmircomUsers(
        searchTerm?: string,
    ): CancelablePromise<Array<SearchedUserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Users/EmircomUsers',
            query: {
                'searchTerm': searchTerm,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns UserInfoDto OK
     * @throws ApiError
     */
    public static getApiUsersUserInfo(
        id: string,
    ): CancelablePromise<UserInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Users/UserInfo/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param pageNumber
     * @param pageSize
     * @param filterByRole
     * @param search
     * @param sortBy
     * @param sortOrder
     * @returns UserListDtoPaginatedResult OK
     * @throws ApiError
     */
    public static getApiUsers(
        pageNumber?: number,
        pageSize?: number,
        filterByRole?: Array<string>,
        search?: string,
        sortBy?: string,
        sortOrder?: string,
    ): CancelablePromise<UserListDtoPaginatedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Users',
            query: {
                'PageNumber': pageNumber,
                'PageSize': pageSize,
                'FilterByRole': filterByRole,
                'Search': search,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static postApiUsers(
        id: string,
        requestBody?: AddUserCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Users/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @returns UserInfoDto OK
     * @throws ApiError
     */
    public static getApiUsersLoggedInUserProfile(): CancelablePromise<UserInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Users/loggedInUserProfile',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
